import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from "react";
import { Input } from "@/components/ui";
import { Select, SelectContent, SelectTrigger, SelectValue } from "@/components/ui";
import DeselectableSelectItem from "@/components/ui/select/deselectable-select-item";
import { cx, hasErrorInput } from "@/lib/tailwind-utils";
export interface SelectOption {
  label: string;
  value: string | number;
}
interface SingleSelectInputProps {
  value?: string | number | boolean;
  onChange: (value: string) => void;
  options?: SelectOption[] | string[];
  placeholder?: string;
  hasError?: boolean;
  errorMessage?: string;
  formatOption?: (option: string) => string;
  id?: string;
  className?: string;
  disabled?: boolean;
  /** Picking the chosen option again clears the value to "". */
  allowDeselect?: boolean;
}
const SingleSelectInput: React.FC<SingleSelectInputProps> = t0 => {
  const $ = _c(41);
  const {
    value: t1,
    onChange,
    options: t2,
    placeholder,
    hasError,
    errorMessage,
    formatOption,
    id,
    className,
    disabled,
    allowDeselect: t3
  } = t0;
  const rawValue = t1 === undefined ? "" : t1;
  const options = t2 === undefined ? [] : t2;
  const allowDeselect = t3 === undefined ? false : t3;
  const value = rawValue == null ? "" : String(rawValue);
  let t4;
  if ($[0] !== formatOption) {
    t4 = option => {
      if (typeof option === "string") {
        return {
          label: formatOption ? formatOption(option) : option,
          value: option
        };
      }
      return option;
    };
    $[0] = formatOption;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const formattedOptions = options.map(t4);
  const otherOptionValue = formattedOptions.find(_temp)?.value;
  const [otherValue, setOtherValue] = useState("");
  const [internalSelectValue, setInternalSelectValue] = useState(value);
  let t5;
  if ($[2] !== value) {
    t5 = value.toLowerCase() === "other" || typeof value === "string" && value.toLowerCase().startsWith("other: ");
    $[2] = value;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const isOtherSelected = t5;
  useEffect(() => {
    if (typeof value === "string" && value.toLowerCase().startsWith("other: ")) {
      if (otherOptionValue) {
        setInternalSelectValue(String(otherOptionValue));
      }
      setOtherValue(value.replace(/other:\s*/i, ""));
    } else {
      setInternalSelectValue(value);
    }
  }, [value, otherOptionValue]);
  const handleOtherValueChange = e => {
    const newOtherValue = e.target.value;
    setOtherValue(newOtherValue);
    if (newOtherValue) {
      onChange(`other: ${newOtherValue}`);
    } else {
      onChange(otherOptionValue ? String(otherOptionValue) : "Other");
    }
  };
  let t6;
  if ($[4] !== className) {
    t6 = cx("flex w-full flex-col", className);
    $[4] = className;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const T0 = Select;
  let t7;
  if ($[6] !== onChange) {
    t7 = newValue => {
      setInternalSelectValue(newValue);
      if (newValue.toLowerCase() !== "other") {
        setOtherValue("");
        onChange(newValue);
      } else {
        onChange(newValue);
      }
    };
    $[6] = onChange;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = placeholder || "Select an option";
  let t9;
  if ($[8] !== t8) {
    t9 = <SelectValue placeholder={t8} />;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== hasError || $[11] !== id || $[12] !== t9) {
    t10 = <SelectTrigger hasError={hasError} id={id} className="px-2.5 py-1.5" wrapText={true}>{t9}</SelectTrigger>;
    $[10] = hasError;
    $[11] = id;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  const T1 = SelectContent;
  const t11 = "bottom";
  const t12 = true;
  let t13;
  if ($[14] !== allowDeselect || $[15] !== internalSelectValue || $[16] !== onChange) {
    t13 = (option_0, index) => <DeselectableSelectItem key={index} value={String(option_0.value)} onDeselect={allowDeselect && String(option_0.value) === internalSelectValue ? () => {
      setInternalSelectValue("");
      setOtherValue("");
      onChange("");
    } : undefined}>{option_0.label}</DeselectableSelectItem>;
    $[14] = allowDeselect;
    $[15] = internalSelectValue;
    $[16] = onChange;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  const t14 = formattedOptions.map(t13);
  let t15;
  if ($[18] !== T1 || $[19] !== t14) {
    t15 = <T1 side={t11} wrapText={t12}>{t14}</T1>;
    $[18] = T1;
    $[19] = t14;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== T0 || $[22] !== disabled || $[23] !== internalSelectValue || $[24] !== t10 || $[25] !== t15 || $[26] !== t7) {
    t16 = <T0 value={internalSelectValue} onValueChange={t7} disabled={disabled}>{t10}{t15}</T0>;
    $[21] = T0;
    $[22] = disabled;
    $[23] = internalSelectValue;
    $[24] = t10;
    $[25] = t15;
    $[26] = t7;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== handleOtherValueChange || $[29] !== hasError || $[30] !== isOtherSelected || $[31] !== otherValue) {
    t17 = isOtherSelected && <div className="mt-2"><Input placeholder="Please specify other value" value={otherValue} onChange={handleOtherValueChange} className={cx(hasError && hasErrorInput)} /></div>;
    $[28] = handleOtherValueChange;
    $[29] = hasError;
    $[30] = isOtherSelected;
    $[31] = otherValue;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== errorMessage || $[34] !== hasError) {
    t18 = hasError && errorMessage && <p id="error-message" className="mt-1.5 text-caption text-red-600">{errorMessage}</p>;
    $[33] = errorMessage;
    $[34] = hasError;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== t16 || $[37] !== t17 || $[38] !== t18 || $[39] !== t6) {
    t19 = <div className={t6}>{t16}{t17}{t18}</div>;
    $[36] = t16;
    $[37] = t17;
    $[38] = t18;
    $[39] = t6;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  return t19;
};
export default SingleSelectInput;
function _temp(opt) {
  return String(opt.value).toLowerCase() === "other";
}